export const servicesTitle = 'Services from this code:';
